import type { StickyFooterProps } from './StickyFooter.typed';
import * as Styled from './StickyFooter.styled';

export const StickyFooter = (props: StickyFooterProps) => {
  const { children, ...rest } = props;
  return <Styled.StickyFooter {...rest}>{children}</Styled.StickyFooter>;
};
